export default "__VITE_ASSET__223f713d__"